export default __webpack_public_path__ + "static/media/238.5d4b14ce.png";